<template>
  <section class="product-detail">
    <div class="product">
      <h2 class="title"><i class="icon fas fa-microchip"></i>Tecnologia</h2>
      <p class="description">Chega de ligar várias vezes para seus clientes cobrando as notas eletrônicas. O NF-Stock Alterdata faz a importação automática de todas as notas recebidas por seus clientes direto do site da Receita Federal, utilizando o certificado digital.</p>
    </div>

    <div class="product">
      <h2 class="title"><i class="icon fas fa-tachometer-alt"></i>Produtividade</h2>
      <p class="description">O Alterdata Pack importa os dados e lança a nota no Escrita Fiscal. Você será notificado da importação através do Gerente Eletrônico Alterdata. É possível visualizar e fazer o download do XML ou da DANFE sempre que precisar.</p>
    </div>

    <div class="product">
      <h2 class="title"><i class="icon fas fa-shield-alt"></i>Segurança</h2>
      <p class="description">O NF-Stock protege seu cliente contra fraudes! Todas as notas emitidas contra o CNPJ do seu cliente serão automaticamente baixadas do site da Receita Federal ou da Prefeitura, evitando que as notas geradas indevidamente passem despercebidas.</p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ProductDetail'
}
</script>